<p>
  Use to display alert messages with different types (success, info, warning, error), sizes (small, medium, large), and optional actions.
</p>
<h2>Use When</h2>
<ul>
  <li>Displaying important messages to users</li>
  <li>Providing feedback after actions</li>
  <li>Highlighting important information</li>
</ul>
<h2>Behavior</h2>
<ul>
  <li>Supports multiple alert types: success, info, warning, error</li>
  <li>Supports multiple sizes: small, medium, large (default is medium)</li>
  <li>Allows custom actions with an optional action button</li>
  <li>The alert can be closed using the close icon (default is closeable)</li>
</ul>
<p>
  Import the
  <app-text-code>AlertComponent</app-text-code>
  in your app.module.ts and use it via
  <app-text-code>&lt;mad-alert&gt;</app-text-code>
  .
</p>

<p>Basic usage with optional values</p>
<example-viewer [example]="alertsComponent"></example-viewer>
<h2>API Specification</h2>
<app-alert-demo-api-spec></app-alert-demo-api-spec>
